module.exports = __webpack_public_path__ + "img/why-choose-us-game.0c1171ce.webp";